import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { SnCurrentUser } from '@lib/auth';
import { SnFormFieldConfig, ISnHasForm } from '@lib/form';
import { t, TranslationService } from '@lib/translation';
import { SnUserFieldsGeneratorService } from '@lib/users';

interface IFormModel {
  badge: string;
}

@Component({
  selector: 'sn-change-badge-dialog',
  templateUrl: './change-badge.dialog.html',
  styleUrls: ['./change-badge.dialog.scss'],
})
export class SnChangeBadgeDialogComponent implements OnDestroy, OnInit, ISnHasForm<IFormModel> {

  public readonly form = new UntypedFormGroup({});
  public formFields: SnFormFieldConfig[] = [];

  public formModel: IFormModel = {
    badge: this._currentUser.badge,
  };

  public isLoading = false;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _matDialogRef: MatDialogRef<SnChangeBadgeDialogComponent>,
    private readonly _currentUser: SnCurrentUser,
    private readonly _userFieldsGeneratorService: SnUserFieldsGeneratorService,
    private readonly _translationService: TranslationService,
  ) {}

  public ngOnInit(): void {
    if (this._translationService.getActiveLang()) {
      this._createFormFields();
    }
  }

  private _createFormFields(): void {
    this.formFields = [
      this._userFieldsGeneratorService.getBadgeField({
        templateOptions: {
          required: true,
          hideRequiredMarker: true,
        },
      }),
    ];
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submitForm(): void {
    this.isLoading = true;

    this._currentUser
      .updateProfile(this.form.value)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => (this.isLoading = false)),
      )
      .subscribe((user) => {
        this._matDialogRef.close(user);
      });
  }

  public cancel(): void {
    this._matDialogRef.close();
  }
}
